import { render, staticRenderFns } from "./SelecionarTipoPagamento.vue?vue&type=template&id=042ef42e&scoped=true"
import script from "./SelecionarTipoPagamento.vue?vue&type=script&lang=js"
export * from "./SelecionarTipoPagamento.vue?vue&type=script&lang=js"
import style0 from "./SelecionarTipoPagamento.vue?vue&type=style&index=0&id=042ef42e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ef42e",
  null
  
)

export default component.exports